import { render, staticRenderFns } from "./HonorBoard.vue?vue&type=template&id=3bbe59d9&scoped=true"
import script from "./HonorBoard.vue?vue&type=script&lang=js"
export * from "./HonorBoard.vue?vue&type=script&lang=js"
import style0 from "./HonorBoard.vue?vue&type=style&index=0&id=3bbe59d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe59d9",
  null
  
)

export default component.exports